import React, { useEffect } from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';
import { faqStudent, faqSchool } from '../data/faqContent';
import { useAudience } from '../contexts/AudienceContext';

const FAQSection = () => {
  const { isSchool } = useAudience();
  const items = isSchool ? faqSchool : faqStudent;

  useEffect(() => {
    const list = isSchool ? faqSchool : faqStudent;
    const faqLd = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: list.map((item) => ({
        '@type': 'Question',
        name: item.q,
        acceptedAnswer: {
          '@type': 'Answer',
          text: item.a,
        },
      })),
    };
    const id = 'crc-faq-jsonld';
    let el = document.getElementById(id);
    if (!el) {
      el = document.createElement('script');
      el.id = id;
      el.type = 'application/ld+json';
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(faqLd);
  }, [isSchool]);

  return (
    <section className="py-20 md:py-24 bg-white scroll-mt-24">
      <div className="container mx-auto px-6 max-w-3xl">
        <div className="text-center mb-12">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-gray-900 mb-4 tracking-tight">
            FAQs
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            {isSchool
              ? 'Everything principals and coordinators usually ask before a pilot or partnership.'
              : 'Straight answers for students and parents, before you take the next step.'}
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full rounded-2xl border border-gray-200 bg-gray-50/50 px-4 md:px-6">
          {items.map((item, i) => (
            <AccordionItem key={item.q} value={`item-${i}`} className="border-gray-200">
              <AccordionTrigger className="text-left text-base font-semibold text-gray-900 hover:text-blue-700 py-5">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-gray-600 leading-relaxed text-[15px] pb-5">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQSection;
